"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _FolderMove = _interopRequireDefault(require("@rsuite/icon-font/lib/file/FolderMove"));

// Generated by script, don't edit it please.
var FolderMove = (0, _createSvgIcon["default"])({
  as: _FolderMove["default"],
  ariaLabel: 'folder move',
  category: 'file',
  displayName: 'FolderMove'
});
var _default = FolderMove;
exports["default"] = _default;
module.exports = exports.default;